import React, { useState, useRef } from "react";
import { Button, Dialog, DialogContent, DialogActions, DialogTitle, DialogContentText } from '@mui/material';
import TextField from '@mui/material/TextField';
import Modal from 'react-bootstrap/Modal';
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Input, MenuItem, Select, InputLabel } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Switch from "@mui/material/Switch";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import * as dayjs from "dayjs";

const NewExtraModal = (props) => {

  const [active, setActive] = useState(true);

  const [name, setName] = useState(props.selectedExtra.name);
  const [type, setType] = useState(props.selectedExtra.type);
  const [range, setRange] = useState([props.selectedExtra.startDate, props.selectedExtra.endDate]);
  const [price, setPrice] = useState(props.selectedExtra.price);

  const getCurrencyAsString = () => {
    switch (props.currency) {
      case 1:
        return "€";
      case 2:
        return "£"
      case 3:
        return "$"
    }
  }

  const clearUI = () => {
    setName("");
    setRange([new Date(`${new Date().getFullYear()}-07-01`), null]);
    setPrice(null);
    setType(0);
    setActive(true);
  }

  const handleSubmit = () => {
    let extra_tmp = props.selectedExtra;
    extra_tmp.name = name;
    extra_tmp.active = active;
    extra_tmp.price = price;
    extra_tmp.type = type;

    extra_tmp.startDate = dayjs(range[0]).format("YYYY-MM-DD");
    extra_tmp.endDate = extra_tmp.type == 0 ? dayjs(range[0]).format("YYYY-MM-DD") : dayjs(range[1]).format("YYYY-MM-DD");

    if (extra_tmp.price >= 10000){
      extra_tmp.price = 10000
    }

    props.setSelectedExtra(extra_tmp);
    props.handleSubmit();
   
  }

  return (
    <>
      {props.selectedExtra ?

        <Modal {...props} size="s" centered>

          <Modal.Body>
            <Grid container spacing={1}>
              <Grid item xs={9}>
                <label htmlFor="name">Name</label>
              </Grid>
              <Grid item xs={3}>
                <FormControlLabel control={<Switch onChange={(e) => setActive(e.target.checked)} checked={active} />} label="Active" />
              </Grid>
            </Grid>

            <TextField
              type="text"
              className="form-control"
              name="locality"
              size="small"
              value={name}
              onChange={(e) => setName(e.target.value)}>
            </TextField>

            <FormControl>
              <label htmlFor="type">Type</label>
              <RadioGroup row>
                <FormControlLabel value={1} control={<Radio value={1} checked={type == 1} onChange={(e) => setType(e.target.value)} />} label="Sport" />
                <FormControlLabel value={0} control={<Radio value={0} checked={type == 0} onChange={(e) => setType(e.target.value)} />} label="Extra" />
              </RadioGroup>
            </FormControl>

            {type == 1 ?

              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                localeText={{ start: '', end: '' }}>
                <DateRangePicker
                  inputFormat="DD/MM/YYYY"
                  value={range}
                  onChange={(newValue) => {
                    setRange(newValue);
                  }}
                  renderInput={(startProps, endProps) => (
                    <React.Fragment>
                      <Grid container spacing={1}>
                        <Grid item xs={5}>
                          <label htmlFor="firstname">Start</label>
                          <TextField size="small" {...startProps} />
                        </Grid>
                        <Grid item xs={5} >
                          <label htmlFor="firstname">End</label>
                          <TextField size="small" {...endProps} />
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  )}
                />
              </LocalizationProvider> :
              <>
                <LocalizationProvider dateAdapter={AdapterDayjs} >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label htmlFor="name">Start</label>
                    </Grid>
                    <Grid item xs={6}>
                      <DesktopDatePicker
                        inputFormat="DD/MM/YYYY"
                        value={range[0]}

                        onChange={(newValue) => {
                          setRange([newValue, newValue]);
                        }}
                        renderInput={(params) => <TextField size="small"  {...params} />}
                      />
                    </Grid>
                  </Grid>

                </LocalizationProvider></>



            }

            <Grid item xs={12}>
              <label htmlFor="price">Price</label>
            </Grid>
            <Grid item xs={12}>
              <TextField size="small" value={price} onChange={(e) => setPrice(e.target.value)}
                InputProps={{ endAdornment: <InputAdornment position="end">{getCurrencyAsString()}</InputAdornment> }} />
            </Grid>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="contained" onClick={handleSubmit} fullWidth>
              Submit
            </Button>
          </Modal.Footer>

        </Modal> : <></>}
    </>
  );
};

export default NewExtraModal;